module.exports = __webpack_public_path__ + "img/youtube-icon.7c6e432a.svg";